/*
 * Tienwi · Partner storefronts (Level 2).
 * Records the partner on the cart (cart attribute "partner") so orders show which storefront they came from.
 * The configurator storage reset runs inline in theme.liquid, before the product scripts read it.
 * Mixed carts are flagged in Liquid (snippets/partner-cart-guard) and blocked at checkout by the validation app.
 */
(function () {
  var partner = document.body && document.body.dataset.partner;
  if (!partner) return;

  // On Etching pages the attribute is cleared (only if a partner was recorded), so an empty cart shows Etching again.
  var isCart = document.body.dataset.template && document.body.dataset.template.indexOf('cart') === 0;
  var key = 'tw-partner-attr';
  var last = null;
  try { last = sessionStorage.getItem(key); } catch (e) {}
  if (partner === 'etching') {
    if (isCart || !last || last === 'etching') return;
    partner = '';
  }
  if (last === (partner || 'etching')) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  fetch(root + 'cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ attributes: { partner: partner } })
  }).then(function (r) {
    if (r.ok) { try { sessionStorage.setItem(key, partner || 'etching'); } catch (e) {} }
  }).catch(function () {});
})();
